import { ReactNode } from 'react';
import { useAuth } from '~/utils';

interface PageLayoutProps {
    children: ReactNode;
}

export const PageLayout = ({ children }: PageLayoutProps) => {
    const { logout } = useAuth();
    return (
        <>
            <button className="bg-transparent text-gray-700 border-2 m-4 float-right" onClick={logout}>
                Logout
            </button>
            {children}
        </>
    );
};
